//
//
//
//
//
//
//
//
//
//
//
//

import UiMixin from '@app/Filters/mixins/UiMixin'

import { getCategoriesByShopResource } from '@api/catalog.service'

export default {
  mixins: [UiMixin],
  props: [
    'disabled',
    'value',
    'filters',
    'available',
    'prices',
    'pagination',
    'label',
  ],
  data() {
    return {
      search: '',
      search_filter: {
        label: 'search',
        title: this._('Поиск'),
        id: 'search_id',
      },
      categories: [],
      options: {
        slidesToScroll: 1,
        dots: false,
        preload: true,
        focusOnSelect: false,
        autoplay: false,
        arrows: true,
        prevArrow: '<i class="controls controls--variant_tiny controls--variant_centered controls--appearance_light controls-left "><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M2.28736 7.71079C2.19363 7.61783 2.11924 7.50723 2.06847 7.38537C2.0177 7.26351 1.99156 7.13281 1.99156 7.00079C1.99156 6.86878 2.0177 6.73808 2.06847 6.61622C2.11924 6.49436 2.19363 6.38376 2.28736 6.29079L6.87736 1.71079C6.97109 1.61783 7.04548 1.50723 7.09625 1.38537C7.14702 1.26351 7.17316 1.1328 7.17316 1.00079C7.17316 0.868781 7.14702 0.738075 7.09625 0.616216C7.04548 0.494357 6.97109 0.383756 6.87736 0.290792C6.69 0.104542 6.43655 0 6.17236 0C5.90817 0 5.65472 0.104542 5.46736 0.290792L0.87736 4.88079C0.315558 5.44329 0 6.20579 0 7.00079C0 7.7958 0.315558 8.55829 0.87736 9.12079L5.46736 13.7108C5.65362 13.8955 5.90502 13.9997 6.16736 14.0008C6.29897 14.0016 6.42943 13.9763 6.55127 13.9266C6.6731 13.8768 6.78392 13.8035 6.87736 13.7108C6.97109 13.6178 7.04548 13.5072 7.09625 13.3854C7.14702 13.2635 7.17316 13.1328 7.17316 13.0008C7.17316 12.8688 7.14702 12.7381 7.09625 12.6162C7.04548 12.4944 6.97109 12.3838 6.87736 12.2908L2.28736 7.71079Z" fill="#242424"/></svg></i>',
        nextArrow: '<i class="controls controls--variant_tiny controls--variant_centered controls--appearance_light controls-right"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M6.2958 4.88079L1.7058 0.290792C1.51844 0.104542 1.26498 0 1.0008 0C0.736613 0 0.483161 0.104542 0.295798 0.290792C0.20207 0.383756 0.127676 0.494357 0.0769072 0.616216C0.0261385 0.738075 0 0.868781 0 1.00079C0 1.1328 0.0261385 1.26351 0.0769072 1.38537C0.127676 1.50723 0.20207 1.61783 0.295798 1.71079L4.8958 6.29079C4.98953 6.38376 5.06392 6.49436 5.11469 6.61622C5.16546 6.73808 5.1916 6.86878 5.1916 7.00079C5.1916 7.13281 5.16546 7.26351 5.11469 7.38537C5.06392 7.50723 4.98953 7.61783 4.8958 7.71079L0.295798 12.2908C0.107495 12.4778 0.00117992 12.7319 0.000242233 12.9973C-0.000695449 13.2626 0.103822 13.5175 0.290799 13.7058C0.477777 13.8941 0.731899 14.0004 0.997263 14.0014C1.26263 14.0023 1.5175 13.8978 1.7058 13.7108L6.2958 9.12079C6.8576 8.55829 7.17316 7.7958 7.17316 7.00079C7.17316 6.20579 6.8576 5.44329 6.2958 4.88079Z" fill="#242424"/></svg></i>',
        loop: false,
        fade: false,
        variableWidth: true,
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 6,
            },
          },
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 6,
            },
          },
        ],
      },
    }
  },
  created() {
    // this.getCategories()
  },
  methods: {
    async getCategories() {
      const {
        data: { items },
      } = await getCategoriesByShopResource.execute({ shop: this.label })
      this.categories = items
      let inst = null
      this.categories.push(...items)

      setTimeout(() => {
        inst = setInterval(() => {
          if (this.$refs.slider && this.$refs.slider.destroy) {
            this.$refs.slider.destroy()
            this.$nextTick(() => {
              this.$refs.slider.create()
            })
            setTimeout(() => {
              this.$refs.slider.destroy()
              this.$nextTick(() => {
                this.$refs.slider.create()
              })
            }, 200)
            clearInterval(inst)
          }
        }, 500)
      }, 500)
      // this.$refs.slider.destroy()
      // this.$nextTick(() => {
      //   this.$refs.slider.create()
      // })
    },
  },
}
